import { FC } from 'react'

const VisaIcon: FC = () => (
  <svg
    width="40"
    height="26"
    viewBox="0 0 40 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      y="0.5"
      width="40"
      height="25"
      rx="5"
      fill="#00579F"
    />
    <path
      d="M17.2137 17.8627H14.9353L16.36 9.14991H18.6385L17.2137 17.8627ZM25.4737 9.3639C24.8214 9.11534 24.1288 8.98934 23.4307 8.99224C21.1804 8.99224 19.5958 10.1782 19.5856 11.8755C19.5676 13.1256 20.7198 13.8216 21.5825 14.2384C22.4644 14.6652 22.7651 14.9434 22.7651 15.3229C22.7549 15.9064 22.0521 16.1755 21.3955 16.1755C20.4855 16.1755 19.999 16.037 19.2579 15.7126L18.9572 15.573L18.6385 17.5293C19.1734 17.7692 20.1578 17.9832 21.1804 17.9922C23.5715 17.9922 25.128 16.8243 25.146 15.0177C25.155 14.0255 24.5468 13.2653 23.2336 12.6447C22.4362 12.246 21.9485 11.9768 21.9485 11.5691C21.9575 11.1975 22.3607 10.8179 23.2606 10.8179C23.8443 10.8013 24.4242 10.9156 24.9579 11.1524L25.164 11.2448L25.4737 9.3639ZM28.5034 14.7767L29.4123 12.3384C29.4033 12.3575 29.6004 11.8293 29.7119 11.5049L29.8718 12.255C29.8718 12.255 30.3031 14.3408 30.3966 14.7767H28.5034ZM31.3156 9.14991H29.553C29.0091 9.14991 28.5957 9.30759 28.3615 9.87297L24.977 17.8627H27.3681L27.8468 16.5562H30.7717C30.8381 16.8614 31.0442 17.8627 31.0442 17.8627H33.1537L31.3156 9.14991ZM13.0319 9.14991L10.7997 15.0909L10.5564 13.8858C10.1442 12.496 8.85012 10.9857 7.40625 10.2345L9.45041 17.8537H11.8606L15.4421 9.14991H13.0319Z"
      fill="white"
    />
    <path
      d="M8.73552 9.14844H5.06842L5.03125 9.32526C7.89195 10.0472 9.7852 11.7906 10.5634 13.8855L9.76605 9.88051C9.63541 9.32413 9.2322 9.16758 8.73552 9.14844Z"
      fill="white"
    />
  </svg>
)

export default VisaIcon
